import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import LogoutMixin from '@/helpers/mixins/LogoutMixin';
let SessionExpiredDialog = class SessionExpiredDialog extends Mixins(LogoutMixin) {
    constructor() {
        super(...arguments);
        this.timerShownDelay = 5000;
    }
    valueObserver(newValue) {
        if (newValue) {
            setTimeout(() => {
                this.onRelogin();
            }, this.timerShownDelay);
        }
    }
    onRelogin() {
        this.logout();
        // this.$router.push('/login/client');
        this.$emit('input', false);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], SessionExpiredDialog.prototype, "value", void 0);
__decorate([
    Watch('value', { immediate: true })
], SessionExpiredDialog.prototype, "valueObserver", null);
SessionExpiredDialog = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], SessionExpiredDialog);
export default SessionExpiredDialog;
